import { compose, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { onSelectSubscriptionPlan } from 'redux-app/actionCreators/subscription'
import ComparePlans from './ComparePlans'

export default compose(
  withLocalization('home.main.comparePlans'),
  connect(
    null,
    {
      onSelectSubscriptionPlan,
    },
  ),
  lifecycle<any, any>({
    componentDidMount () {
      const path = window.location.href;
      if (path.indexOf("#compare-plans") > 0){
        const anchor = document.getElementById("compare-plans");
        if(anchor) {
            anchor.scrollIntoView();
        }
      }
    }})
)(ComparePlans)
